import React, {useEffect, useMemo, useState} from 'react';
import {notification, Typography} from 'antd';
import {Navbar} from "../../components/Navbar";
import {authAPI} from "../../services/AuthService";
import {Navigate} from "react-router-dom";
import {FilialGridModel} from "../../models/FilialGridModel";
import {filialAPI} from "../../services/FilialService";
import {CreateFilialModal} from "../../components/FilialsScreen/CreateFilialModal";
import {UpdateFilialModal} from "../../components/FilialsScreen/UpdateFilialModal";
import {FilialModel} from "../../models/FilialModel";
import {
    DataGridPremium,
    GridCellParams,
    gridClasses,
    GridColDef,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton, GridToolbarQuickFilter,
    ruRU
} from "@mui/x-data-grid-premium";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import {Button} from '@mui/material';
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

const {Text} = Typography;
const Context = React.createContext({name: 'FilialsScreen'});

export const FilialsScreen: React.FC = () => {
    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <div style={{display: 'flex', justifyContent: 'space-between', width: window.innerWidth}}>
                    <div style={{display: 'flex'}}>
                        <Button size={'small'} onClick={() => setVisibleCreateFilialModal(true)}
                                startIcon={<AddBoxOutlinedIcon/>}>Добавить</Button>
                        <Button disabled={isGettingFilialsInProcess} size={'small'} onClick={() => getFilialsRequest()}
                                startIcon={<RefreshOutlinedIcon/>}>Обновить</Button>
                        <GridToolbarColumnsButton/>
                        <GridToolbarFilterButton/>
                        <GridToolbarExport/>
                    </div>
                    <div style={{display: 'flex'}}>
                        <GridToolbarQuickFilter/>
                    </div>
                </div>
            </GridToolbarContainer>
        );
    }
    // Notification
    const [api, contextHolder] = notification.useNotification();
    const errorNotification = (message: string) => {
        api.error({
            message: `Ошибка`,
            description: <Context.Consumer>{({name}) => `${message}`}</Context.Consumer>,
            placement: 'topRight',
        });
    };
    const infoNotification = (message: string) => {
        api.success({
            message: `Выполнено`,
            description: <Context.Consumer>{({name}) => `${message}`}</Context.Consumer>,
            placement: 'topRight',
        });
    };
    const contextValue = useMemo(() => ({name: 'Ant Design'}), []);
    // -----
    const [getFilialsRequest, {
        data: dataGetFilialsRequest,
        isLoading: isGettingFilialsInProcess,
        isError,
    }] = filialAPI.useGetFilialsMutation();
    const [redirectToLogin, setRedirectToLogin] = useState<boolean>(false);
    const [data, setData] = useState<FilialGridModel[]>([]);
    const [selectedFilial, setSelectedFilial] = useState<FilialModel | null>(null);
    const [visibleCreateFilialModal, setVisibleCreateFilialModal] = useState<boolean>(false);
    const [visibleUpdateFilialModal, setVisibleUpdateFilialModal] = useState<boolean>(false);
    // Return to login if reject token verify
    const [verifyTokenRequest, {status: statusVerifyTokenRequest}] = authAPI.useVerifyTokenMutation();
    useEffect(() => {
        verifyTokenRequest();
    }, [])
    useEffect(() => {
        if (statusVerifyTokenRequest === 'rejected') {
            setRedirectToLogin(true);
        }
    }, [statusVerifyTokenRequest])
    // -----
    useEffect(() => {
        const token: string | null = localStorage.getItem('token');
        if (token) getFilialsRequest();
        else setRedirectToLogin(true);
    }, [])
    useEffect(() => {
        if (dataGetFilialsRequest) setData(dataGetFilialsRequest);
    }, [dataGetFilialsRequest])
    const columns: GridColDef[] = [
        {fieldName: "Наименование", field: 'name'},
        {fieldName: "Код", field: 'code'},
    ].map((col: { fieldName: string, field: string }) => {
        return {
            field: col.field,
            headerName: col.fieldName,
            minWidth: 400,
            width: 400,
            editable: false,
        }
    })

    return (
        <Context.Provider value={contextValue}>
            {contextHolder}
            <div style={{height: window.innerHeight - 60}}>
                {redirectToLogin && <Navigate to="/login" replace={false}/>}
                {visibleCreateFilialModal &&
                    <CreateFilialModal
                        infoNotification={infoNotification}
                        errorNotification={errorNotification}
                        getFilials={getFilialsRequest}
                        setVisible={setVisibleCreateFilialModal}
                    />}
                {(visibleUpdateFilialModal && selectedFilial) &&
                    <UpdateFilialModal
                        infoNotification={infoNotification}
                        errorNotification={errorNotification}
                        filial={selectedFilial}
                        getFilials={getFilialsRequest}
                        setVisible={setVisibleUpdateFilialModal}/>}
                <Navbar/>
                <DataGridPremium
                    localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
                    rows={data}
                    columns={columns}
                    getRowHeight={() => 'auto'}
                    sx={{
                        [`& .${gridClasses.cell}`]: {
                            py: 1,
                        },
                    }}
                    /*@ts-ignore*/
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    slots={{toolbar: CustomToolbar}}
                    loading={isGettingFilialsInProcess}
                    onCellDoubleClick={(params: GridCellParams) => {
                        setSelectedFilial(params.row);
                        setVisibleUpdateFilialModal(true);
                    }}
                />
            </div>
        </Context.Provider>
    );
}